import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

const SECTIONS = [
  { id: "home",         label: "Home" },
  { id: "ai",           label: "AI" },
  { id: "about",        label: "About" },
  { id: "services",     label: "Services" },
  { id: "expertise",    label: "Journey" },
  { id: "clients",      label: "Clients" },
  { id: "testimonials", label: "Reviews" },
  { id: "contact",      label: "Contact" },
];

export default function SectionDots() {
  const [active, setActive] = useState("home");

  useEffect(() => {
    const observers = [];
    SECTIONS.forEach((s) => {
      const el = document.getElementById(s.id);
      if (!el) return;
      const obs = new IntersectionObserver(
        ([entry]) => { if (entry.isIntersecting) setActive(s.id); },
        { threshold: 0.35 }
      );
      obs.observe(el);
      observers.push(obs);
    });
    return () => observers.forEach((o) => o.disconnect());
  }, []);

  return (
    <motion.aside
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: 1.5, duration: 0.6 }}
      className="hidden xl:flex fixed right-6 top-1/2 -translate-y-1/2 z-40 flex-col items-end gap-3"
    >
      {SECTIONS.map((s) => {
        const isActive = active === s.id;
        return (
          <a
            key={s.id}
            href={`#${s.id}`}
            className="group flex items-center gap-2.5"
            aria-label={s.label}
          >
            <span className="text-[10px] font-mono uppercase tracking-[0.18em] text-[#73100D] opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300">
              {s.label}
            </span>
            <span className="relative flex items-center justify-center w-3 h-3">
              <span className={`relative block rounded-full transition-all duration-300 ${
                isActive
                  ? "w-3 h-3 bg-[#73100D]"
                  : "w-1.5 h-1.5 bg-[#73100D]/35 group-hover:bg-[#73100D]/70"
              }`} />
              {isActive && (
                <motion.span
                  layoutId="section-dot-ring"
                  className="absolute inset-0 rounded-full border border-[#73100D]/40 animate-ping-soft"
                />
              )}
            </span>
          </a>
        );
      })}
    </motion.aside>
  );
}
